export function startsWith(text: string, toFind: string): boolean {
    return text.lastIndexOf(toFind, 0) === 0;
}
